import { useIsCuaReadinessGateKilled } from '@/features/flags/cua-readiness-gate-kill-flag';
import { logger } from '@/utils/logger/logger';
import { rpaBridge } from '@heidi/plugin-rpa';
import { useEffect } from 'react';

export const useSyncCuaReadinessGate = (): void => {
  const enforced = !useIsCuaReadinessGateKilled();

  useEffect(() => {
    if (!rpaBridge.isAvailable()) return;
    rpaBridge.setComputerUseReadinessGateEnforced(enforced).catch((error: unknown) => {
      logger.warn('[cua-readiness] Failed to push the readiness gate flag', {
        error_kind: error instanceof Error ? error.name : typeof error,
      });
    });
  }, [enforced]);
};
